import { render, staticRenderFns } from "./DocSign.vue?vue&type=template&id=2b549d9e&"
import script from "./DocSign.vue?vue&type=script&lang=js&"
export * from "./DocSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports